/*    
<summary>
  This functional component is used for proper authentication of user using the HeadquarterLogin Credentials (Username & Password)
  Developer:Aashish Singh, Created Date:28-Aug-2022, Last Updated By: Mohammad Saquib Khan, Updated Date: 26-Oct-2022
</summary>
<returns>Returns JSX</returns>
*/

import { observer } from "mobx-react";
import { useEffect } from "react";
import { useCookies } from "react-cookie";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import userTypeEnum from "../../constants/enums/user-type-enum";
import { errorMessage } from "../../constants/error-constants";
import { useStore } from "../../contexts/store-provider";
import { getUserTypeFromLocalStorage } from "../../helpers/localstorage-helper";
import { IUserTypeLogin } from "../../models/forms/ILogin";
import Footer from "../../shared-components/footer/footer";
import RoutesConstants from "../../shared-components/routes/routes-constants";
import { formatMessage } from "../../translations/format-message";
import LoginForm from "./forms/login-form";
import "./login.css";

const HeadquarterLogin = (props: any) => {
  const history = useHistory();
  const { authStore } = useStore();

  const { error, inProgress }: any = authStore;
  const { isAuthenticated, getToken, login, loginAsStoreService } = authStore;
  const [headquarterAdminEmailCookies, setHeadquarterEmailCookie, removeHeadquarterCookie] = useCookies(["headquarterEmail"]);
  const headquarterEmailFromCookies = headquarterAdminEmailCookies.headquarterEmail ?? "";
  const initialValues: IUserTypeLogin = {
    email: headquarterEmailFromCookies,
    password: "",
    storeCode: "",
    userType: 5,
    rememberMe: headquarterEmailFromCookies !== "" ? true : false,
  };

  /**
   * This function handles login functionlity for user
   */
  const handleLogin = (values: IUserTypeLogin) => {
    if (values.rememberMe == true) {
      setHeadquarterEmailCookie("headquarterEmail", values.email);
    } else {
      removeHeadquarterCookie("headquarterEmail");
    }
      login({email: values.email, password: values.password, userType: values.userType});
  };

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "isAuthenticated" of the useEffect changed.
   */

  useEffect(() => {
    if (isAuthenticated || getToken) {
      let userType = getUserTypeFromLocalStorage();
      if(userType == userTypeEnum[5]) history.push(RoutesConstants.Dashboard);
      else history.push(RoutesConstants.HeadQuarterLogin);
    }
  }, [isAuthenticated]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "error" of the useEffect changed.
   */
  useEffect(() => {
    if (error) {
      if (error === errorMessage.UserAlreadyLogin) {
        props.confirmLoginPopupToggleHandler();
      } else {
        toast.error(formatMessage(error));
        authStore.reset();
      }
    }
  }, [error]);

  return (
    <>
      <LoginForm
        isLoading={inProgress}
        loginHandler={handleLogin}
        initialValues={initialValues}
      />
      <Footer />
    </>
  );
};

export default observer(HeadquarterLogin);
